<template>
  <v-card class="rounded-card card-shadow" v-if="hasMelhorEnvio">
    <v-card-text class="text--primary pb-8 px-6">
      <div class="title font-weight-bold">
        Pacotes
      </div>
      <div>
        {{ compra.situacao }}
      </div>
      <template v-for="(pacote, index) in compra.pacotes">
        <div :key="index" class="mt-8">
          <px-compra-frete-marketplace class="body-1 font-weight-bold"
                                       :frete="pacote.frete"/>
          <px-compra-pacote-frete-padrao v-if="!isMelhorEnvio(pacote.frete)" :pacote="pacote"/>
          <px-compra-pacote-frete-melhor-envio v-if="isMelhorEnvio(pacote.frete)"
                                               :compra="compra"
                                               :pacote="pacote"
                                               @change="onChangePacote"/>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import CompraPacoteFretePadrao from './CompraPacoteFretePadrao.vue';
import CompraPacoteFreteMelhorEnvio from './CompraPacoteFreteMelhorEnvio.vue';

export default {
  props: {
    compra: Object,
  },
  computed: {
    isMelhorEnvio() {
      return (pacoteFrete) => pacoteFrete.modoFrete === 'MELHOR_ENVIO';
    },
    hasMelhorEnvio() {
      return this.compra.pacotes.some((pacote) => pacote.frete.modoFrete === 'MELHOR_ENVIO');
    },
  },
  methods: {
    onChangePacote() {
      this.$emit('change');
    },
  },
  components: {
    pxCompraPacoteFretePadrao: CompraPacoteFretePadrao,
    pxCompraPacoteFreteMelhorEnvio: CompraPacoteFreteMelhorEnvio,
  },
};
</script>
